var _path, _mask, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "#F15642"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.552C8 16.288 8.208 16 8.543 16H10.39C11.43 16 12.366 16.696 12.366 18.03C12.366 19.294 11.43 19.998 10.39 19.998H9.055V21.054C9.055 21.406 8.831 21.605 8.543 21.605C8.279 21.605 8 21.406 8 21.054V16.552ZM9.055 17.007V18.999H10.39C10.926 18.999 11.35 18.526 11.35 18.03C11.35 17.471 10.926 17.007 10.39 17.007H9.055Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9319 21.605C13.6679 21.605 13.3799 21.461 13.3799 21.11V16.568C13.3799 16.281 13.6679 16.072 13.9319 16.072H15.7629C19.4169 16.072 19.3369 21.605 15.8349 21.605H13.9319ZM14.4359 17.048V20.63H15.7629C17.9219 20.63 18.0179 17.048 15.7629 17.048H14.4359Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6329 17.112V18.383H22.6719C22.9599 18.383 23.2479 18.671 23.2479 18.95C23.2479 19.214 22.9599 19.43 22.6719 19.43H20.6329V21.109C20.6329 21.389 20.4339 21.604 20.1539 21.604C19.8019 21.604 19.5869 21.389 19.5869 21.109V16.567C19.5869 16.28 19.8029 16.071 20.1539 16.071H22.9609C23.3129 16.071 23.5209 16.28 23.5209 16.567C23.5209 16.823 23.3129 17.111 22.9609 17.111H20.6329V17.112Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf.3043f6e9.svg";
export { ForwardRef as ReactComponent };